import { Outlet } from 'react-router-dom';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { ArrowLeft } from 'lucide-react';

import { useLanguage } from '../../hooks/useLanguage';
import { DatascopeSmall } from '../../icons';
import { redirectTo } from '../../utils/navigation';
import { LangSelector } from '../uiComponents/CommonComponents/LangSelector';
import { ImageCarousel } from './ImageCarousel';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    height: '100vh',
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: '60px 30px 40px 30px',
    color: '#3B3C40',
    maxHeight: '100%',
    overflowY: 'auto',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    width: '100%',
    maxWidth: '500px',
  },
  langSelectorContainer: {
    position: 'absolute',
    top: '20px',
    right: '20px',
  },
  logo: {
    width: '60px',
    height: '60px',
    color: (theme) => theme.palette.primary.main,
  },
  backButton: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    zIndex: 1000,
    backgroundColor: '#FFFFFF',
    color: '#3B3C40',
    padding: '5px 16px',
    borderRadius: '16px',
    border: '1px solid #D1D4D9',
    backdropFilter: 'blur(8px)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      transform: 'translateY(-1px)',
    },
    transition: 'all 0.2s ease-in-out',
  },
  backButtonIcon: {
    width: '20px',
    height: '20px',
  },
  backButtonText: {
    fontSize: '14px',
    fontFamily: 'Noto Sans',
    fontWeight: 500,
    lineHeight: '20px',
  },
};

export function AuthLayout() {
  const lang = useLanguage();

  return (
    <Box sx={customStyles.root}>
      <Button
        type='button'
        onClick={() => redirectTo('https://datascope.io/', true)}
        sx={customStyles.backButton}
        aria-label={lang.wizard.back}
      >
        <ArrowLeft />
        <Typography
          display='inline'
          sx={customStyles.backButtonText}
        >
          {lang.mainMenu.home}
        </Typography>
      </Button>
      <ImageCarousel />
      <Box sx={customStyles.contentContainer}>
        <Box sx={customStyles.content}>
          <Box sx={customStyles.langSelectorContainer}>
            <LangSelector />
          </Box>
          <DatascopeSmall sx={customStyles.logo} />
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
